import React, {useEffect, useState} from 'react';
import ReactModal from "react-modal";
import PaymentTypeSelector from "../../PaymentSelector/PaymentTypeSelector";
import {FormProvider, useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import {formatDate, permissionsAccess, returnEndStr} from "../../../../helpers/common";
import {
    changeStateAnnuityClose,
    clearModalError,
    closeDealAnnuity,
    getCalcAnnuityCloseDeal,
    getPrintedForm,
} from "../../../../redux/actions/contractAction";
import LoaderLinear from "../../Loader/Loader";
import './closeAnnuityDeal.scss';
import InfoPanel from "../CloseModalLayout/InfoPanel";
import moment from "moment";
import {HCheckbox} from "../../../../validation/HForm";
import {Message} from "../../index";
import {viewReports} from "../../../../helpers/data-constants";
import {authService} from "../../../../services/auth-service";
import {ConfirmModal} from "../../../common";

const CloseAnnuityDeal = ({
                              isOpen,
                              onClose,
                              dealId,
                              openBuyThirdPersonModal,
                              isBuyThirdPerson: {data},
                              items,
                              updateData
                          }) => {
    const [paymentInputs, setPaymentInputs] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const {
        calcAnnuityData,
        isModalLoading,
        isSuccessCloseAnnuityDeal,
        isDisabledButton,
        modalError,
        closeAnnuityData
    } = useSelector(({contract}) => contract);
    const [change, setChange] = useState(0);

    const dispatch = useDispatch();
    const dataActiveCashbox = authService.getActiveCashBoxId();
    const form = useForm({
        mode: 'all',
        defaultValues: {
            deposit: {
                cash: 0,
                nonCash: 0,
                bankTransaction: 0
            }
        },
    });

    const cashValue = form.watch('deposit.cash') || 0;
    const nonCashValue = form.watch('deposit.nonCash') || 0;
    const nonCashAccountValue = form.watch('deposit.nonCashAccount') || 0;
    const bankTransactionValue = form.watch('deposit.bankTransaction') || 0;
    const cashValueMinusChange = +cashValue - change

    useEffect(() => {
        if (isSuccessCloseAnnuityDeal) {
            updateData();

            items.forEach((item, index) => {
                const filename =
                    'exp_' +
                    item.dealNumber +
                    '_' +
                    item.startDate +
                    '_' +
                    item.endDate +
                    '.pdf';
                return dispatch(
                    getPrintedForm({
                        dealId: item.id ? item.id : item.dealId,
                        dealType: item.type,
                        cashBoxId: dataActiveCashbox.value,
                        operationId: closeAnnuityData.operationIds[index]
                    }, filename, viewReports.CLOSE_DEAL_RECEIPT)
                );
            });
            dispatch(changeStateAnnuityClose())
            onClose();
        }
    }, [isSuccessCloseAnnuityDeal]);

    useEffect(() => {
        if (!dealId) return;
        const data = {
            dealIds: dealId,
            closureDate: moment().format("YYYY-MM-DD")
        };
        dispatch(getCalcAnnuityCloseDeal(data));
    }, []);

    const submit = () => {
        const payload = {
            deals: calcAnnuityData?.deals?.map((el) => ({dealId: el.dealId, checkSum: el.checkSum})),
            deposit: {
                cash: +cashValueMinusChange.toFixed(2),
                nonCash: +nonCashValue,
                nonCashAccount: +nonCashAccountValue,
                bankTransaction: +bankTransactionValue,
            }
        }
        if (data) {
            payload.closureByAnotherPerson = data
        }
        dispatch(closeDealAnnuity(payload))
    };

    const onChange = (e) => {
        openBuyThirdPersonModal(e.target.checked);
    };

    const onCloseHandler = () => setConfirmOpen(true);

    const getHandleAction = () => {
        onClose();
        setConfirmOpen(false);
        dispatch(clearModalError())
    };

    function sumDays(penaltiesArray) {
        if (!Array.isArray(penaltiesArray)) return 0;

        return penaltiesArray.reduce((total, penalty) => {
            return total + (penalty.days || 0);
        }, 0);
    }

    const onCloseModal = () => setConfirmOpen(false);

    return (
        <ReactModal
            isOpen={isOpen}
            contentLabel="Закрытие договора"
            className="modal-container clientContract-modal-container payAnnuityPeriod closeAnnuityDeal"
            overlayClassName="modal-overlay"
        >
            <LoaderLinear isLoading={isModalLoading}/>
            <h2 className='closeAnnuityDeal-title'>Закрытие договора</h2>
            {modalError && <Message type="error" text={modalError}/>}
            {
                !isModalLoading &&
                <FormProvider {...form}>
                    <form onSubmit={form.handleSubmit(submit)} className='closeAnnuityDeal-blocks'>
                        {calcAnnuityData?.deals?.map((deal, index) => (
                            <div className='closeAnnuityDeal-itemBlocks'>
                                <div className='closeAnnuityDeal-ItemBlock'>
                                    <span className='closeAnnuityDeal-text'>Погашено микрозаймов:</span>
                                    <span>{deal?.dealAmount} руб.</span>
                                </div>

                                {deal?.recalculation > 0 && (
                                    <div className='closeAnnuityDeal-ItemBlock closeAnnuityDeal-expired'>
                                        <span className='closeAnnuityDeal-text closeAnnuityDeal-expired'>Перерасчет по микрозайму:</span>
                                        <span>{deal?.recalculation} руб.</span>
                                    </div>
                                )}

                                {deal?.overpaymentTotal > 0 && (
                                    <div className='closeAnnuityDeal-ItemBlock'>
                                    <span className='closeAnnuityDeal-text'>
                                        Процент за пользование микрозаймом
                                        <span className='closeAnnuityDeal-dealNumber'> № {deal?.dealNumber}</span>:
                                    </span>
                                        <span>{deal?.overpaymentTotal} руб.</span>
                                    </div>
                                )}
                                {deal?.penaltyDtoList?.length > 0 && (<InfoPanel
                                        key="penalty-info-panel"
                                        panelKey="paidPayments"
                                        headerClassName='closeAnnuityDeal-infoItem'
                                        extra={`${deal.penaltyAmount} руб`}
                                        title={<span>
        Начисленная неустойка № <strong>{items[index]?.dealNumber}</strong> за {returnEndStr(sumDays(deal?.penaltyDtoList))}
    </span>}
                                        rows={deal.penaltyDtoList.map((payment) => ({
                                            title: `${formatDate(payment.dateFrom)} - ${formatDate(payment.dateTo)} за ${returnEndStr(payment?.days)}`,
                                            value: payment.amount
                                        }))}
                                    />
                                )}
                                <div className='closeAnnuityDeal-ItemBlock'>
                                <span
                                    className='closeAnnuityDeal-text closeAnnuityDeal-dealNumber'>№ {deal?.dealNumber}</span>
                                    <span>{deal?.totalAmount} руб.</span>
                                </div>
                            </div>
                        ))}
                        <div className='closeAnnuityDeal-closureByAnotherPerson'>
                            <HCheckbox name='closureByAnotherPerson' className='input' onChange={onChange}/>
                            <span>Выкуп третьим лицом</span>
                        </div>
                        <div className='closeAnnuityDeal-payBLock'>
                            <PaymentTypeSelector
                                form={form}
                                maxTotalSum={calcAnnuityData.finalCharge || 0}
                                calculateTotalSum={calcAnnuityData.finalCharge || 0}
                                inputFieldName={'deposit'}
                                setPaymentInputs={setPaymentInputs}
                                setCashChangePayment={setChange}
                            />
                        </div>

                        <div className="payAnnuityPeriod-actionButtons">
                            <button className="button-light" type="button" onClick={onCloseHandler}>
                                Отменить
                            </button>
                            {permissionsAccess('accept.money') && (
                                <button
                                    className={!paymentInputs || isDisabledButton ? "button-light" : "button"}
                                    type="submit"
                                    disabled={!paymentInputs}
                                >
                                    Принять деньги
                                </button>
                            )}
                        </div>
                    </form>
                </FormProvider>
            }
            <ConfirmModal
                isOpen={confirmOpen}
                handleClose={onCloseModal}
                headerText={'Отменить закрытие договора?'}
                handleAction={getHandleAction}
            />
        </ReactModal>
    );
};

export default CloseAnnuityDeal;
